// @flow
import { observable } from "mobx";
import { observer } from "mobx-react";
import React from "react";

import Video from "app/models/Video";
import GlobalSettingsStore from "app/stores/GlobalSettingsStore";
import VideoCards from "app/components/VideoCards/VideoCards";

import "./AdminVideosView.scss";

type Props = {
    videos: any[],
    serverTime: any
};

@observer
export default class AdminVideosView extends React.Component<Props> {
    @observable videos: Video[];

    constructor(props: Props) {
        super(props);
        this.videos = Video.makeArray(this.props.videos);
    }

    render() {
        return (
            <div className="AdminVideosView">
                <VideoCards
                    videos={this.videos}
                    serverTime={this.props.serverTime}
                    theme={GlobalSettingsStore.videoCardTheme}
                    breakpointClasses="col-lg-4 col-md-6 col-sm-6"
                    timelineThumbnail
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/views/app/admin/Videos/AdminVideosView.js